import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/home';

export default function LatestArticles() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6" aria-labelledby="articles-title">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 id="articles-title" className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新文章
            </h2>
            <p className="mt-2 text-sm text-foreground-600">深度评测与选购指南，帮你发现好国货</p>
          </div>
          <Link
            to="/category"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 bg-accent-500 text-white text-xs px-2.5 py-1 rounded-full">
                  {article.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-500">
                    <i className="ri-calendar-line mr-1"></i>{article.date}
                  </span>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-time-line mr-1"></i>{article.readTime}
                  </span>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-eye-line mr-1"></i>{article.views.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}